import { Outlet } from 'react-router-dom';
import LeftMainNavigation from '../common/leftMenuNavigation/leftMenuNavigation';
import styles from "./managerDashboard.module.scss";
import { useEffect, useState } from 'react';
import { leftMenuNavigationListProps } from '../../infrastructure/GlobalContextProvider';
import { apiRequest } from '../../infrastructure/backendService';
 
import apiPath from "../../config/apiPaths.json";
 
// interface ManagerDashboardProps {
//    userRoleId: string | null;
// }
 
const ManagerDashboard = () => {
   const [managerMenuList, setManagerMenuList] = useState<leftMenuNavigationListProps[]>([]);
   const userRoleId = sessionStorage.getItem("userRoleId");
 
   useEffect(()=>{
      apiRequest({
         method: "GET",
         includeToken: true,
         endpoint: apiPath.administrativeMenus,
         params: {
           categoryId: userRoleId,
           page: 0,
           size: 20,
           direction: "asc"
         },
       })
      .then((res)=>{
         const content = res.data.content
         if (Number(userRoleId) !== 63) {
            content.push({id: "1a2", key: "OFFICE_DEVOTEE_SERVICE", title: "Office Devotee Service", "subMenus": []})
         }
         setManagerMenuList(content);
      })
      .catch((err)=>{
         console.log(err)
      })
   },[userRoleId])
 
   return (
      <div className={styles.leftMenuNavigationAndOutlet}>
         <LeftMainNavigation menuList={managerMenuList} mainRoutePath="managerDashboard" />
         <div style={{ width: '100%' }}>
            <Outlet />
         </div>
      </div>
   );
};
 
export default ManagerDashboard;